<template>
  <EBanner
    v-if="consentVisible"
    class="cookie-notice"
    data-track-id="cookie_consent"
    :headline="$t('common.cookienotice.title')"
    :description="description"
    :has-close-action="false"
  >
    <template #image>
      <img
        :src="require('~~/common/vue/assets/images/cookie.png')"
        alt=""
      >
    </template>
    <template #actions>
      <div class="cookie-consent__actions">
        <EButton
          class="cookie-consent__action"
          data-test-id="cookie-notice-reject"
          data-track-id="cookie_consent_reject"
          variant="solid-green"
          size="m"
          @click.stop="reject"
        >
          {{ $t('common.cookienotice.reject') }}
        </EButton>
        <EButton
          class="cookie-consent__action"
          data-test-id="cookie-notice-accept"
          data-track-id="cookie_consent_accept"
          variant="solid-green"
          size="m"
          @click.stop="accept"
        >
          {{ $t('common.cookienotice.accept') }}
        </EButton>
      </div>
    </template>
  </EBanner>
</template>

<script>
import { mapState } from 'vuex';

import { sendCoreAnalyticsEvent } from '~~/common/js/client/analytics';

import EBanner from '~~/common/vue/components/banner';
import EButton from '~~/common/vue/components/button';

export default {
  name: 'ECookieNotice',
  components: {
    EBanner,
    EButton,
  },
  computed: {
    ...mapState('user', [
      'consentVisible',
    ]),
    description() {
      const learnMoreText = this.$t('common.cookienotice.learnmore');
      return `${this.$t('common.cookienotice.description')} ${learnMoreText}`;
    },
  },
  mounted() {
    const consentGiven = this.$cookieManager.getConsentGiven();
    const consentDisabled = !!this.$route?.query.disableConsent;
    const consentVisible = !consentGiven && !consentDisabled;

    this.$store.commit('user/set', { consentVisible });
    this.$cookieManager.setConsentValidation(true);

    if (consentVisible) {
      sendCoreAnalyticsEvent('cookieNoticeDisplay');
    }
  },
  methods: {
    setUserConsent() {
      this.$store.commit('user/set', {
        consentGiven: true,
        consentVisible: false,
      });
    },
    reject() {
      this.$cookieManager.rejectNonEssential();
      this.setUserConsent();
      sendCoreAnalyticsEvent('cookieNoticeClickReject');
    },
    accept() {
      this.$cookieManager.acceptAll();
      this.setUserConsent();
      sendCoreAnalyticsEvent('cookieNoticeClickAccept');
    },
  },
};
</script>

<style lang="scss" scoped>
.cookie-notice {
  position: fixed;
  color: var(--color-text-primary);
  background-color: var(--color-background-elevation-1);
  bottom: 0;
  z-index: $z-index-overlay;

  ::v-deep a {
    color: var(--color-link-primary);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.cookie-consent__actions {
  display: flex;
  flex-direction: column-reverse;

  @include tablet {
    flex-direction: row;
  }
}

.cookie-consent__action {
  width: 100%;

  &:first-child {
    margin-top: $space-m;
  }

  @include tablet {
    width: auto;

    &:first-child {
      margin-top: 0;
    }

    &:nth-child(2) {
      margin-left: $space-m;
    }
  }
}
</style>
